<!-- <div>
  <input (input)="onSearch(search.value)" #search type="text">
  <i class="fas fa-search"></i>
</div> -->

<div class="SearchParts">
  <i class="fas fa-search icon"></i>
  <input (input)="onSearch(search.value)" #search type="text">
</div>

<div class="form-group preserve-newlines" style='overflow-y:auto;max-height: 400px;'>
  <div *ngFor="let item of comments| search:'Comment':searchQuery;trackBy: trackNote">
    <div>
      <p style="display: inline;">{{item.Person}} @  {{moment(moment.utc(item.date)).local().format("dddd, MMMM Do YYYY, h:mm:ss a")}}&nbsp;&nbsp;</p>
      <i *ngIf="hasPermission" class="fas fa-trash-alt" style="cursor: pointer;" (click)="onDelete(item.id, content); "></i>
    </div>
    <b><p>{{item.Comment}}</p></b>
  </div>
</div>

<div class="form-group">
  <label for="comment">Add Comment:</label>
  <textarea class="form-control" rows="5" id="comment" #comment></textarea>
</div>

<button (click)="onAddNote(comment.value)" type="button" class="btn btn-success">Save Note</button>
<div style="color: red;">*Any notes that have not been saved will not save unless you click 'Save Note'</div>



<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Delete Confirmation</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modal.close('Delete click')">Delete</button>
    <button type="button" class="btn btn-secondary" (click)="modal.close('Cancel click')">Cancel</button>
  </div>
</ng-template>
